module.exports = __webpack_public_path__ + "static/desktop/img/logo-transparent.7bcd249e.svg";